import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import ListLayout from "../../../../../partials/content/ListLayout";
import { getIncomingPaymentDetail } from "../../../../../services/finance/incomingPayment";
import IncomingPaymentBasicInfo from "./incomingPaymentBasicInfo";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function IncomingPaymentDetail({ match, history }) {
  const { reload } = useGlobalData();
  const paymentID = match.params.paymentID;
  const [payment, setPayment] = useState({
    ID: 0,
    vendor: {
      vendorName: "",
    },
  });
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getIncomingPaymentData(paymentID);
  }, [paymentID, reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/payments/AR",
            title: "Payments",
            active: false,
          },
          {
            page: "/finance/incoming-payment-detail/" + paymentID,
            title: "A/R Payment ID " + payment.incomingPaymentCode,
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/payments/AR");
            },
          },
        ]}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <IncomingPaymentBasicInfo payment={payment} />
                );
                setHeaderTitle("Basic Info");
                break;
              case "attachments":
                selectedComponent = (
                  <Attachments docType="PAYR" docID={payment.ID} />
                );
                setHeaderTitle("Attachments");
                break;
              case "notes":
                selectedComponent = <Notes docType="PAYR" docID={payment.ID} />;
                setHeaderTitle("Notes");
                break;
              default:
                selectedComponent = (
                  <IncomingPaymentBasicInfo payment={payment} />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getIncomingPaymentData(paymentID) {
    const response = await getIncomingPaymentDetail(paymentID);
    const { data } = response.data;
    const componentTmp = (
      <IncomingPaymentBasicInfo payment={data.incomingPayment} />
    );
    setPayment(data.incomingPayment);
    setComponent(componentTmp);
  }
}

export default IncomingPaymentDetail;
